/**
 * A company domain as the backend matches it: a bare host such as acme.com or
 * eu.acme.com. Sign-up compares it with the part of someone's email after the
 * @, so "https://acme.com" or "ada@acme.com" would save but never match anyone.
 */
export const BARE_DOMAIN_MESSAGE =
  "Enter just the domain, like acme.com — no https://, no email address, no path.";

export const isBareDomain = (value: string): boolean =>
  /^(?!-)[a-z0-9-]+(\.[a-z0-9-]+)+$/.test(value);
